import ReactJson from "react-json-view";
import { useInfiniteQuery, useMutation } from "@tanstack/react-query";
import { useInView } from "react-intersection-observer";
import { fetchAllTickets, fetchKanbanTickets, fetchUpdateAssingTo, fetchupdateLane, fetchupdateToKanbanBoard } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash.debounce";
import { queryClient } from "../../App";
import Modal from "../modal/Modal";
import TicketDetails from "./TicketDetails";
const swimLanes = [
    { id: 'todo', label: 'Todo' },
    { id: 'inprogress', label: 'In Progress' },
    { id: 'done', label: 'Done' }
]

const mockTasks = [
    { pk: 1, title: 'Remove jira', lane: 'todo' },
    { pk: 2, title: 'Remove Confluence', lane: 'todo' },
    { pk: 3, title: 'Member Protal', lane: 'inprogress' },
    { pk: 4, title: 'CSR Protal', lane: 'inprogress' },
    { pk: 5, title: 'AWS connect', lane: 'inprogress' },
    { pk: 6, title: 'HRP portal', lane: 'done' }
]

function flattenInPlace(arr) {
    let i = 0;
    while (i < arr.length) {
        if (Array.isArray(arr[i])) {
            // Remove the nested array and insert its elements
            arr.splice(i, 1, ...arr[i]);
        } else {
            i++;
        }
    }
    return arr; // Returns the modified original array
}

const Kanban = () => {
    // const [tasks, setTasks] = useState(mockTasks);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [dropover, setDropover] = useState()
    const [selectedItem, setSelectedItem] = useState()
    const [isDragging, setIsDragging] = useState(false); //false or the task id


    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState();
    const [lastUpdatedAt, setLastUpdatedAt] = useState()
    const { ref, inView } = useInView();

    const queryKey = ['kanban', decouncedSearchValue];

    const {
        data,
        refetch,
        fetchNextPage,
        fetchPreviousPage,
        isLoading, //first time only
        isFetching,

        hasNextPage,
        isFetched,
        hasPreviousPage,
        isFetchingNextPage,
        isFetchingPreviousPage,
        isError,
        status,
        error
    } = useInfiniteQuery({
        retry: false,
        refetchOnWindowFocus: true,
        queryKey,
        queryFn: ({ pageParam }) => {
            let params = { lastEvaluatedKey: pageParam };

            if (decouncedSearchValue) {
                params.ticketPrefix = decouncedSearchValue
            }

            return fetchKanbanTickets(params)
        },
        select: (data) => {
            return {
                pages: data.pages.map((page) => page.Items).flatMap((x) => x),
                pageParams: data.pageParams,
            };
            // return { ...data.hits, timestamp: Date.now() }
        },
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.LastEvaluatedKey ? encodeURIComponent(JSON.stringify(lastPage.LastEvaluatedKey)) : null
        },

        staleTime: 0,//,Infinity,
        enabled: true  //&& !!showChat
    })

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    // const data = originalData?.pages.map((page) => page.Items).flatMap((x) => x)
    // console.log({ originalData })
    const tasks = data?.pages?.flat() //?.map(t => ({ id: t.pk, content: t.title, lane: t.lane }));

    const updateLaneHandler = async (body) => {
        // console.log('update lane', body)
        return await fetchupdateLane({
            pk: body.pk,
            sk: body.sk,
            lane: body.lane,
            indexToInsert: body.indexToInsert
        })
    }

    const mutation = useMutation({
        mutationFn: updateLaneHandler,
        onSuccess: (data, variables) => {

            if (!data) return

            queryClient.setQueryData(queryKey, (oldData => {
                if (oldData) {
                    for (let i = 0; i < oldData.pages.length; i++) {
                        let page = oldData.pages[i];
                        page.Items = page.Items.map((item) => {
                            if (item.pk === variables.pk && item.sk === variables.sk) {
                                item = { ...item, ...data }
                            }
                            return item;
                        });

                        oldData.pages[i] = page;
                    }
                }
                return oldData
            }));
        },
        onError: (err) => {
            console.log(err)
            // setError(err?.response?.data?.message || err.message)
        }
    })

    const onDragStart = (data) => {
        setIsDragging(data)
        //  console.log('selected', data)
        setSelectedItem(data)
    }

    const onDragEnd = (data) => {
        //    console.log('drag end', data)
        setIsDragging(false)
    }

    const onDragOver = (e, sl) => {
        e.preventDefault()
        // console.log(e.target)
        // console.log('drag over', { ...sl, overTaskPk: e.target.id?.split('#')[0] })
        setDropover({ ...sl, overTaskPk: e.target.id?.split('#')[0] })
    }

    const onDropHandler = async (e) => {
        e.preventDefault();
        setIsDragging(false);
        console.log('dropped',)
        //TODO persist in db

        const taskToEdit = tasks.find(t => t.pk == selectedItem.taskPk)

        let allOtherTasks = tasks.filter(t => t.pk !== selectedItem.taskPk)
        // console.log(dropover)
        if (dropover.overTaskPk && !swimLanes.some(sl => sl.id == dropover.overTaskPk)) {

            const indexToInsert = allOtherTasks.findIndex(task => task.pk == dropover.overTaskPk);

            if (indexToInsert !== -1) {
                const taskDroppedOver = tasks.find(t => t.pk === dropover.overTaskPk)

                const updatedTask = { ...taskToEdit, lane: dropover.id, indexToInsert: taskDroppedOver.indexToInsert - 1 }
                allOtherTasks.splice(indexToInsert, 0, updatedTask);

                //    console.log('update ticket to persist', updatedTask)
                await mutation.mutateAsync(updatedTask)
                //   console.log('ticket to persist', { ...taskToEdit, lane: dropover.id, indexToInsert })
            }

        } else {
            const updatedTask = { ...taskToEdit, lane: dropover.id, indexToInsert: Date.now() }
            // console.log('first ticket to persist', updatedTask)
            allOtherTasks.push(updatedTask)
            await mutation.mutateAsync(updatedTask)
        }

        // console.log(allOtherTasks)

        // setTasks(prev => {
        //     const taskToEdit = prev.find(t => t.pk == selectedItem.taskPk)

        //     let data = prev.filter(t => t.pk !== selectedItem.taskPk)

        //     if (dropover.overTaskId && !swimLanes.some(sl => sl.id == dropover.overTaskPk)) {
        //         const indexToInsert = data.findIndex(task => task.pk == dropover.overTaskPk);
        //         if (indexToInsert !== -1) {
        //             data.splice(indexToInsert, 0, { ...taskToEdit, lane: dropover.id });
        //         }

        //     } else {
        //         data.push({ ...taskToEdit, lane: dropover.id })
        //     }

        //     return data
        // })

    }

    const updateAssigToMutation = useMutation({
        mutationFn: async (body) => {
            return await fetchUpdateAssingTo({
                pk: body.pk,
                sk: body.sk,
                assignTo: body.assignTo
            })
        },
        onSuccess: (data, variables) => {

            if (!data) return

            queryClient.setQueryData(queryKey, (oldData => {
                if (oldData) {
                    for (let i = 0; i < oldData.pages.length; i++) {
                        let page = oldData.pages[i];
                        page.Items = page.Items.map((item) => {
                            if (item.pk === variables.pk && item.sk === variables.sk) {
                                item = { ...item, ...data }
                            }
                            return item;
                        });

                        oldData.pages[i] = page;
                    }
                }
                return oldData
            }));
        },
        onError: (err) => {
            console.log(err)
            // setError(err?.response?.data?.message || err.message)
        }
    })

    // console.log(data?.pages)
    const selectedTikcet = tasks?.find(ticket => ticket.pk === isModalOpen.pk);
    // console.log({ selectedTikcet })

    return (
        <>
            <Modal isOpen={selectedTikcet} onClose={() => { setIsModalOpen(false); }}>
                <div style={{ width: '100%', padding: '1rem' }}>
                    {/* <p>{selectedTikcet?.updatedAt}</p> */}
                    <TicketDetails data={selectedTikcet} queryKey={queryKey} updateAssigToMutation={updateAssigToMutation} />
                    {/* 
                    <ReactJson
                        style={{ padding: "1rem" }}
                        src={data || ""}
                        name={false}
                        collapsed={1}
                        collapseStringsAfterLength={150}
                        displayDataTypes={false}
                        displayObjectSize={false}
                        sortKeys={true}
                    /> */}
                </div>
            </Modal>

            <div className="lanes" >
                {
                    swimLanes.map(sl => (<div
                        className="swim-lane"
                        draggable="false"
                        onDragOver={(e) => onDragOver(e, sl)}
                        onDrop={onDropHandler}
                        id={sl.id}
                        key={sl.id} >
                        <p className="swim-lane-title" > {sl.label} </p>
                        < div className="tasks" >
                            {
                                tasks?.filter(task => task.lane === sl.id)
                                    .sort((a, b) => {
                                        return a.indexToInsert - b.indexToInsert

                                        // if (a.indexToInsert) {
                                        //     return b.indexToInsert - a.indexToInsert
                                        // } else {
                                        //     a.updatedAt.localeCompare(b.updatedAt)
                                        // }

                                    })
                                    .map(task => (<div
                                        key={task.pk}
                                        id={task.pk}

                                        className={`task ${isDragging === task.pk ? 'is-dragging ' : ''}`}

                                        onClick={() => setIsModalOpen(task)}
                                        onDragStart={() => onDragStart({ taskPk: task.pk, swimLaneId: sl.id })}
                                        onDragEnd={() => onDragEnd({ taskPk: task.pk })}
                                    >
                                        <div id={`${task.pk}#div`}
                                            draggable="true"
                                            style={{ backgroundColor: dropover?.overTaskPk === task.pk && isDragging ? 'var(--lighterGrey)' : '' }}
                                        >
                                            {/* <p id={`${task.pk}#index`}>{task.indexToInsert} </p> */}
                                            <p id={`${task.pk}#pk`}> {task.pk} </p>
                                            <p id={`${task.pk}#title`} style={{ padding: '1rem 0rem', fontWeight: 600 }}>{task.title} </p>
                                            <p id={`${task.pk}#desc`}> {task.desc} </p>
                                            <p id={`${task.pk}#updatedAt`} style={{ padding: '1rem 0rem' }}> {task.updatedAt} </p>

                                            <p id={`${task.pk}#desc`}> {task.assignTo} </p>
                                        </div>




                                    </div>))}
                        </div>
                    </div>))}


            </div>
        </>
    )
}

export default Kanban